// extracted by mini-css-extract-plugin
module.exports = {"header":"copy-feature-component_header__DVpO5","content":"copy-feature-component_content__2H9IV","text":"copy-feature-component_text__KpYyc"};